module.exports = __webpack_public_path__ + "static/img/leftIcon.89573346.png";